// TODO: adding required polyfills or dont use language features -> What should be target?
// https://webpack.js.org/guides/shimming/#loading-polyfills
// https://github.com/ryanelian/ts-polyfill

// NOTE: this seems to be smaller than importing the individual polyfill packages.
import 'ts-polyfill';
import 'whatwg-fetch';


import { init } from './init';
import { preLoadDebugScript } from './debug-loader';

(async function run() {
  await preLoadDebugScript();
  // passes the pre-load xng object.
  init(window[window.CrossEngageObject] as any);
})();
